module.exports = __webpack_public_path__ + "img/logo.0d7b1de2.jpg";